import { lazy } from 'react';

export const YourBirthtimePageLazy = lazy(() => import('./your-birthtime'));
